/* Stooner · Carrito lateral (1/3): utilidades, dinero y pintado del carrito */
(function () {
  'use strict';
  if (window.__scd) return;

  var S = { cart: null, loaded: false, internal: 0, lastFocus: null, loading: null, again: false, wasOpen: false, toastT: 0, extT: 0 };

  function root() { return document.querySelector('[data-scd]'); }
  function q(sel, ctx) { return (ctx || root() || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root() || document).querySelectorAll(sel)); }
  function conf(k) { var r = root(); return r ? r.getAttribute('data-' + k) : null; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function parse(s) { try { return JSON.parse(s); } catch (e) { return []; } }

  function fmtMoney(cents, format) {
    var fmt = format || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      var v = (n / 100).toFixed(precision);
      var parts = v.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var p = m ? m[1] : 'amount';
    var value;
    switch (p) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(cents, 2, ' ', '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(re, value);
  }

  function money(cents) {
    var cur = S.cart && S.cart.currency;
    var shopCur = conf('shop-currency');
    if (cur && shopCur && cur !== shopCur) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) {}
    }
    return fmtMoney(cents, conf('money-format'));
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(
        function (data) { return { ok: res.ok, status: res.status, data: data }; },
        function () { return { ok: res.ok, status: res.status, data: {} }; }
      );
    });
  }

  function getCart() {
    var base = conf('cart-url') || '/cart';
    return fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function refresh() {
    if (!root()) return Promise.resolve(null);
    if (S.loading) { S.again = true; return S.loading; }
    S.loading = getCart()
      .then(function (cart) { S.cart = cart; S.loaded = true; render(); syncBubble(); return cart; })
      .catch(function () { return null; })
      .then(function (c) {
        S.loading = null;
        if (S.again) { S.again = false; return refresh(); }
        return c;
      });
    return S.loading;
  }

  function syncBubble() {
    var n = S.cart ? S.cart.item_count : 0;
    qa('cart-icon', document).forEach(function (el) {
      try { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(n, false); } catch (e) {}
    });
  }

  var ICON_MINUS = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 6h10" stroke="currentColor" stroke-width="1.4"/></svg>';
  var ICON_PLUS = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 6h10M6 1v10" stroke="currentColor" stroke-width="1.4"/></svg>';

  function itemHtml(it) {
    var img = (it.featured_image && it.featured_image.url) || it.image || '';
    var alt = (it.featured_image && it.featured_image.alt) || it.product_title || '';
    var imgHtml = img
      ? '<img src="' + esc(sized(img, 240)) + '" srcset="' + esc(sized(img, 160)) + ' 160w, ' + esc(sized(img, 240)) + ' 240w, ' + esc(sized(img, 360)) + ' 360w" sizes="80px" alt="' + esc(alt) + '" width="80" height="120" loading="lazy">'
      : '';

    var opts = '';
    if (!it.product_has_only_default_variant && it.options_with_values) {
      it.options_with_values.forEach(function (o) {
        opts += '<p class="scd-item__opt">' + esc(o.name) + ': ' + esc(o.value) + '</p>';
      });
    }
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
      opts += '<p class="scd-item__opt">' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>';
    }
    if (it.properties) {
      Object.keys(it.properties).forEach(function (k) {
        var v = it.properties[k];
        if (k.charAt(0) === '_' || v === '' || v == null) return;
        opts += '<p class="scd-item__opt">' + esc(k) + ': ' + esc(v) + '</p>';
      });
    }
    var disc = '';
    (it.line_level_discount_allocations || []).forEach(function (d) {
      if (d.discount_application && d.discount_application.title) disc += '<p class="scd-item__disc">' + esc(d.discount_application.title) + '</p>';
    });

    var price = '';
    if (it.original_line_price > it.final_line_price) price += '<s>' + esc(money(it.original_line_price)) + '</s>';
    price += esc(money(it.final_line_price));

    var remove = conf('show-remove') === 'true'
      ? '<button type="button" class="scd-item__remove" data-scd-remove>' + esc(conf('remove-label') || 'Eliminar') + '</button>'
      : '';

    return '<li class="scd-item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
      '<a class="scd-item__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
      '<div class="scd-item__main">' +
        '<div class="scd-item__top">' +
          '<a class="scd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<div class="scd-item__price">' + price + '</div>' +
        '</div>' +
        opts + disc +
        '<div class="scd-item__actions">' +
          '<div class="scd-qty">' +
            '<button type="button" data-scd-minus aria-label="Quitar una unidad">' + ICON_MINUS + '</button>' +
            '<span class="scd-qty__n" aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-scd-plus aria-label="Añadir una unidad">' + ICON_PLUS + '</button>' +
          '</div>' +
          remove +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function render() {
    var r = root();
    if (!r) return;
    var cart = S.cart;
    var n = cart ? cart.item_count : 0;
    var empty = n === 0;
    r.classList.toggle('is-empty', empty);

    var cnt = q('[data-scd-count]', r);
    if (cnt) cnt.textContent = conf('show-count') === 'true' && n > 0 ? ' (' + n + ')' : '';

    var list = q('[data-scd-items]', r);
    if (list) list.innerHTML = cart ? cart.items.map(itemHtml).join('') : '';

    var emptyBox = q('[data-scd-empty]', r);
    if (emptyBox) emptyBox.hidden = !(S.loaded && empty);

    var foot = q('[data-scd-foot]', r);
    if (foot) foot.hidden = empty || !cart;
    if (cart) {
      var sub = q('[data-scd-subtotal]', r);
      if (sub) sub.textContent = money(cart.total_price);
      var dRow = q('[data-scd-discount-row]', r);
      if (dRow) {
        var hasDisc = cart.total_discount > 0;
        dRow.hidden = !hasDisc;
        var dv = q('[data-scd-discount]', r);
        if (dv && hasDisc) dv.textContent = '-' + money(cart.total_discount);
      }
    }
    renderShipping();
    syncUpsell();
  }

  function renderShipping() {
    var ship = q('[data-scd-ship]');
    if (!ship) return;
    var th = Number(conf('threshold')) || 0;
    var cart = S.cart;
    if (!th || !cart || cart.item_count === 0) { ship.hidden = true; return; }
    ship.hidden = false;
    var left = th - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / th) * 100));
    var msg = q('[data-scd-ship-msg]', ship);
    if (msg) msg.textContent = left > 0 ? (conf('ship-msg') || '').replace('{amount}', money(left)) : (conf('ship-ok') || '');
    var fill = q('[data-scd-fill]', ship);
    if (fill) fill.style.width = pct + '%';
    var bar = q('[data-scd-bar]', ship);
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(pct)));
  }

  function animateBar() {
    var fill = q('[data-scd-fill]');
    var th = Number(conf('threshold')) || 0;
    if (!fill || !S.cart || !th) return;
    var pct = Math.max(0, Math.min(100, (S.cart.total_price / th) * 100));
    fill.style.transition = 'none';
    fill.style.width = '0%';
    void fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(function () { fill.style.width = pct + '%'; });
  }

  function track() { return q('[data-scd-track]'); }

  function updateArrows() {
    var tr = track();
    if (!tr) return;
    var prev = q('[data-scd-arrow="-1"]');
    var next = q('[data-scd-arrow="1"]');
    var nav = q('.scd-up__nav');
    if (nav) nav.hidden = !(tr.scrollWidth > tr.clientWidth + 4);
    if (prev) prev.disabled = tr.scrollLeft <= 2;
    if (next) next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
  }

  function syncUpsell() {
    var r = root();
    var wrap = q('[data-scd-up]', r);
    if (!wrap) return;
    var inCart = {};
    (S.cart ? S.cart.items : []).forEach(function (i) { inCart[String(i.product_id)] = true; });
    var any = false;
    qa('.scd-up__card', r).forEach(function (c) {
      var hide = !!inCart[c.getAttribute('data-pid')];
      c.hidden = hide;
      if (!hide) any = true;
    });
    wrap.hidden = !any || !S.loaded;
    updateArrows();
  }

  window.__scd = {
    S: S, root: root, q: q, qa: qa, conf: conf, esc: esc, parse: parse, post: post, money: money,
    refresh: refresh, render: render, syncBubble: syncBubble, animateBar: animateBar,
    track: track, updateArrows: updateArrows
  };
})();